import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

/**
 * Open the inventory at `to` (from utils/branchView inventoryLink) and jump
 * to the top: the SPA keeps the window scroll across routes, and without the
 * reset the inventory would open part-way down (as BranchAiValueTable does).
 */
export function useOpenInventory() {
    const navigate = useNavigate();
    return useCallback((to) => {
        navigate(to);
        // 'instant' overrides the global `html { scroll-behavior: smooth }`.
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }, [navigate]);
}

/**
 * A real link into the inventory (copy, middle-click, new tab all work); a
 * plain click navigates inside the app and jumps to the top.
 */
export default function InventoryLink({ to, className, children, ...rest }) {
    const open = useOpenInventory();
    const onClick = (e) => {
        e.stopPropagation();
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        open(to);
    };
    return (
        <a href={to} className={className} onClick={onClick} {...rest}>
            {children}
        </a>
    );
}

InventoryLink.propTypes = {
    to: PropTypes.string.isRequired,
    className: PropTypes.string,
    children: PropTypes.node,
};
